import { useCallback, useRef } from 'react';

// Shared Crypto modal calls confirm then hide in one synchronous click.
// The exact request identity, rather than a global boolean, owns that phase.
export default function useSportsBonusModalPhase() {
  const ownerRef = useRef(null);
  const open = useCallback(request => {
    ownerRef.current = { request, phase: 'prompt' };
    return request;
  }, []);
  const beginConfirm = useCallback(request => {
    const owner = ownerRef.current;
    if (!request || owner?.request !== request || owner.phase !== 'prompt') return false;
    owner.phase = 'confirming';
    return true;
  }, []);
  const hide = useCallback(request => {
    const owner = ownerRef.current;
    if (!request || owner?.request !== request) return 'stale';
    if (owner.phase === 'confirming') return 'hide';
    ownerRef.current = null;
    return 'cancel';
  }, []);
  const complete = useCallback(request => {
    if (ownerRef.current?.request !== request) return false;
    ownerRef.current = null;
    return true;
  }, []);
  const rearm = useCallback(request => {
    if (ownerRef.current?.request !== request) return false;
    ownerRef.current.phase = 'prompt';
    return true;
  }, []);
  const reset = useCallback(() => { ownerRef.current = null; }, []);
  return { open, beginConfirm, hide, complete, rearm, reset };
}

